function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4977",
    transform: "translate(-223 -34)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 132",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(223 34)",
    style: {
      fill: "#46c756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-whatsapp",
    d: "M12.08 4.315A7.043 7.043 0 0 0 1 12.811l-1 3.647 3.733-.98a7.019 7.019 0 0 0 3.365.856 7.108 7.108 0 0 0 7.107-7.04 7.068 7.068 0 0 0-2.125-4.979zM7.1 15.148a5.841 5.841 0 0 1-2.981-.815l-.212-.127-2.214.58.59-2.16-.14-.222a5.863 5.863 0 1 1 10.875-3.11A5.917 5.917 0 0 1 7.1 15.148zm3.209-4.383c-.174-.089-1.04-.514-1.2-.571s-.279-.089-.4.089-.453.571-.558.691-.206.133-.381.044a4.788 4.788 0 0 1-2.391-2.092c-.181-.311.181-.289.517-.961a.326.326 0 0 0-.016-.308c-.044-.089-.4-.955-.542-1.307s-.289-.295-.4-.3-.219-.006-.336-.006a.652.652 0 0 0-.469.219A1.977 1.977 0 0 0 3.52 7.73a3.446 3.446 0 0 0 .717 1.82 7.861 7.861 0 0 0 3.006 2.658 3.442 3.442 0 0 0 2.112.441 1.8 1.8 0 0 0 1.186-.837 1.471 1.471 0 0 0 .1-.837c-.041-.075-.157-.124-.331-.21z",
    transform: "translate(228 36.75)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.a89bbc14983c3aa11225c15e3ba4a13e.svg";
export { ForwardRef as ReactComponent };